<div class="row">
	@if (enableHeader) {
		<h5 class="card-title placeholder-glow">
			<span class="placeholder col-6"></span>
		</h5>
	}
	<p class="card-text placeholder-glow">
		@for (place of places; track place) {
			<span class="placeholder col-{{ place.col }}"></span>
		}
	</p>
	@if (enableButton) {
		<div class="d-flex justify-content-end">
			<a class="btn btn-primary disabled placeholder col-2" aria-disabled="true"></a>
		</div>
	}
</div>
